import {useFormContext} from "react-hook-form";

import {Alert} from "@/components/alert/Alert.tsx";
import {Card} from "@/components/card/Card.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
import {SwitchField} from "@/components/form/fields/SwitchField.tsx";
import {ServiceField} from "@/lib/constants/service.ts";

export const CheckManualMaintenanceForm = () => {
  const {watch} = useFormContext();
  const isUnderManualMaintenance = watch(ServiceField.IS_UNDER_MANUAL_MAINTENANCE);
  const pauseUnderManualMaintenance = watch(ServiceField.PAUSE_UNDER_MANUAL_MAINTENANCE);
  const scheduledMaintenanceSchedules = watch(ServiceField.MAINTENANCE_SCHEDULE_IDS) || [];
  const hasSchedules = scheduledMaintenanceSchedules.length > 0;
  return (
    <div className={"pulseMaxWidthXL d-flex flex-column gap-3"}>
      <Card variant={"white"}>
        <SwitchField
          name={ServiceField.IS_UNDER_MANUAL_MAINTENANCE}
          label={"Under Maintenance Now"}
          description={"Alerts will be suppressed until you change this setting"}
          labelPosition={"left"}
        ></SwitchField>
        {isUnderManualMaintenance && (
          <>
            <Divider className="my-3" />
            <SwitchField
              name={ServiceField.PAUSE_UNDER_MANUAL_MAINTENANCE}
              labelPosition={"left"}
              label={"Stop check execution during maintenance mode"}
              description={"Pauses checks during maintenance. When off, checks still run but alerts are suppressed."}
            />
          </>
        )}
      </Card>
      {isUnderManualMaintenance && pauseUnderManualMaintenance && hasSchedules && (
        <Alert variant={"maintenance"} callout={"Linked schedules paused for this check only"}>
          Other checks on these schedules are unaffected. Turn this off to resume scheduled maintenance.
        </Alert>
      )}
    </div>
  );
};
